import React from 'react';

import {AccountPageShell} from 'app/account/components/AccountPageShell';
import {FullHTMLLink} from 'app/components/general/FullHTMLLink';
import {HeadingText} from 'app/components/general/HeadingText';
import {BreadcrumbItemStructure} from 'app/general/structures/BreadcrumbItemStructure';
import {useReports} from 'app/reports/api';
import {ACCOUNT_REPORT_URL} from 'app/urls';
import {gt} from 'app/utils/i18n';

import {ReportSerializedType} from 'sweet-types';

import type {BreadcrumbProps} from 'app/general/structures/BreadcrumbItemStructure';

export function ReportsPage(): JSX.Element {
  const {data: reports, error, isLoading} = useReports();

  return (
    <AccountPageShell
      title={gt('Reports')}
      location="reports"
      isLoading={isLoading}
      error={error}
      content={(reports?.count ?? 0) > 0 ? reports : undefined}
      errorContent={{head: gt('Could not load the reports at the moment')}}
      noResultsContent={gt('No report templates available at the moment')}
    >
      {(reports) => (
        <>
          <HeadingText>{gt('Available Reports')}</HeadingText>
          <div className="border-bottom d-sm-none" />

          <div className="list-group">
            {reports.results.map((report: ReportSerializedType) => (
              <FullHTMLLink
                key={report.url}
                html_url={report.html_url}
                className="list-group-item list-group-item-action"
              >
                {report.name}
              </FullHTMLLink>
            ))}
          </div>
        </>
      )}
    </AccountPageShell>
  );
}

export const ReportsBreadcrumb = (props: BreadcrumbProps) => (
  <BreadcrumbItemStructure
    {...props}
    text={gt('Reports')}
    link={ACCOUNT_REPORT_URL}
  />
);
